import { useState } from 'react'

import { Item } from '../../models/Item'
import { getIconNameFromType } from '../../utils/item'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { CurrencyField } from '../common/fields/CurrencyField'
import { TextField } from '../common/fields/TextField'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    isOpen: boolean
    onClose: () => void
    item: Item
    onDone: (updatedItem: Item) => void
    onMoreDetails?: () => void
    title?: string
    type?: string
    shouldHideDepositField?: boolean
}

export const ItemLiteModal = ({
    isOpen,
    onClose,
    item,
    onDone,
    onMoreDetails,
    title,
    type,
    shouldHideDepositField = true,
}: Props) => {
    const [name, setName] = useState(item.name ?? '')
    const [rate, setRate] = useState(item.rate ?? 0)
    const [deposit, setDeposit] = useState(item.deposit ?? 0)

    const handleDone = () => {
        onDone(
            item.clone({
                name,
                rate: deposit > rate ? deposit : rate,
                deposit,
            })
        )
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            footer={
                <div className="flex w-full items-center justify-end gap-x-4">
                    {onMoreDetails !== undefined && (
                        <Button intent="secondary" onClick={onMoreDetails}>
                            Show more details
                        </Button>
                    )}
                    <Button onClick={handleDone} intent="primary">
                        Save
                    </Button>
                </div>
            }
            width={744}
        >
            <div className="flex flex-col items-stretch justify-start gap-y-8">
                <WorkflowPage.IconSection
                    title="Name (required)"
                    icon={`${getIconNameFromType(type ?? '')}.large`}
                >
                    <TextField
                        size="medium"
                        placeholder="Name"
                        value={name ?? ''}
                        onChange={(event) => setName(event.target.value)}
                        onClear={() => setName('')}
                    />
                </WorkflowPage.IconSection>

                <WorkflowPage.IconSection title="Price" icon="dollar.large">
                    <CurrencyField
                        size="medium"
                        placeholder="Price"
                        value={rate ?? 0}
                        onChange={(rate) => setRate(rate ?? 0)}
                    />
                </WorkflowPage.IconSection>

                {!shouldHideDepositField && (
                    <WorkflowPage.IconSection title="Deposit" icon="safe.large">
                        <CurrencyField
                            size="medium"
                            placeholder="Price"
                            value={deposit ?? 0}
                            onChange={(deposit) => setDeposit(deposit ?? 0)}
                        />
                    </WorkflowPage.IconSection>
                )}
            </div>
        </Modal>
    )
}
